import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
	Outlet,
	RouterProvider,
	createRootRoute,
	createRoute,
	createRouter,
} from "@tanstack/react-router";
import { createRoot } from "react-dom/client";
// Styles are included by @repo/forms-ui component package

import FormRoute from "./routes/form.$org.$slug";
import Index from "./routes/index";
import { ThemeProvider } from "./theme/ThemeProvider";

const rootRoute = createRootRoute({
	component: () => <Outlet />,
});

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/",
	component: Index,
});

const formRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/forms/$org/$slug",
	component: FormRoute,
});

const routeTree = rootRoute.addChildren([indexRoute, formRoute]);

const router = createRouter({
	routeTree,
	basepath: "/",
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const queryClient = new QueryClient();

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<ThemeProvider>
				<RouterProvider router={router} />
			</ThemeProvider>
		</QueryClientProvider>
	);
}

const el = document.getElementById("root");
if (!el) throw new Error("Root element not found");
createRoot(el).render(<App />);

export default App;
